import React, { useEffect, useState, useMemo } from "react";
import "./addlessons.scss";
import { FormControl, Grid } from "@mui/material";
import { InputField } from "../../../../library/custom/textBox/InputField";
import SelectMenu from "../../../../library/custom/selectMenu/SelectMenu";
import FormLabels from "../../../../library/custom/formLabel/FormLabels";
import TextArea from "../../../../library/custom/textArea/TextArea";
import Button from "../../../../library/custom/button/Button";
import { useSelector, useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import { formValidation } from "../../../../utils/incpectionHelper";
import Section from "../../../../library/custom/section/Section";
import AddIcon from "@mui/icons-material/Add";
import { CREATE_QUIZ, LESSON } from "../../../../constant/routeContant";
import { useNavigate } from "react-router-dom";
import {
  ORG_ID,
  HBNEXT_ORG_ID,
  SEFETY_HBN_CLIENT_PARTNER_PRI,
  SW_HBN_CLIENT_PARTNER_PRI,
} from "../../../../constant/constant";
import {
  checkPrivileges,
  hasAllPrivileges,
  showRighSideMenu,
} from "../../../../utils/rolesHelper";
import Checkbox from "../../../../library/checkbox/checkbox";
import * as lmsAction from "../../../../redux/actions/lmsAction";
import { InactiveClient, sortAlphabetically } from "../../../../utils/helper";
import ImageUploader from "../../../../library/custom/media/ImageEditor ";
import BackBtn from "../../../../library/custom/backBtn/backBtn";
const AddLessons = ({
  categoryListData,
  onSubmit,
  lessonDetailData,
  isCloneOf,
  isLessonEditMode,
  editid,
}) => {
  const location = useLocation();
  const { pathname } = location;
  const quizDetails = location?.state?.quizDetailsData?.data;
  const lessonData = location?.state?.lessonInputData;
  const isQuiz = location?.state?.isQuiz;
  const edit = pathname.split("/")[2] ?? null;
  const [errors, setErrors] = useState({});
  const [images, setImages] = useState([]);
  const navigate = useNavigate();
  const [isSubmit, setIsSubmit] = useState(false);
  const dispatch = useDispatch();

  const userId = localStorage.getItem("userId");
  const [addPhoto, setAddPhoto] = useState("");
  const [addPhotos, setAddPhotos] = useState(null);
  const [addDocs, setAddDocs] = useState("");
  const [checkBox, setcheckBox] = useState(
    edit && lessonDetailData ? null : false,
  );
  const showMenu = showRighSideMenu();
  const isShowClient =
    parseInt(ORG_ID()) === parseInt(HBNEXT_ORG_ID) && checkPrivileges([12]);
  const showSafety =
    showMenu?.isSafety &&
    (isShowClient || hasAllPrivileges(SEFETY_HBN_CLIENT_PARTNER_PRI));

  const showSW =
    showMenu?.isSW &&
    (isShowClient || hasAllPrivileges(SW_HBN_CLIENT_PARTNER_PRI));

  const { isSuccess, editLessonData } = useSelector(
    (state) => state.updateLesson,
  );
  const intialState = {
    id: Date.now() + Math.floor(Math.random() * 100),
    organisationId: ORG_ID(),
    createdBy: userId,
    createdByApp: 1,
    isDocAdded: false,
    embededVideoLink: "",
    imgFiles: [],
    docFiles: [],
    isImageAdded: false,
    Text: "",
  };
  const [sectionList, setSectionList] = useState([intialState]);

  function validateEmbededVideoLink(data) {
    const videoRegex =
      /^(https:\/\/(?:www\.)?(?:vimeo\.com\/(?:video\/|embed\/)?[0-9]+(\?.*)?|player\.vimeo\.com\/video\/[0-9]+(\?.*)?|youtube\.com\/embed\/[A-Za-z0-9_-]{11}(\?.*)?))$/;

    let validationResults = [];
    data?.forEach((item) => {
      const videoLink = item?.embededVideoLink;
      let isInValid = true;
      if (videoLink) {
        if (videoRegex?.test(videoLink)) {
          isInValid = false;
        }
      } else {
        isInValid = false;
      }
      validationResults?.push(isInValid);
    });

    return validationResults;
  }

  const formHandler = (event, action) => {
    const embValidData = validateEmbededVideoLink(sectionList);
    const hasSectionErr = embValidData?.some((val) => val === true);
    if (InactiveClient()) return;
    const iscategryAvilable = categoryListData?.categoryList?.filter((val) => {
      return val?.key === formValue?.categoryId;
    });

    if (iscategryAvilable.length === 0) {
      setFormValue({
        ...formValue,
        categoryId: "",
      });
    }

    const quizData = quizDetails
      ? {
          createdBy: quizDetails.createdBy ?? 0,
          title: quizDetails.title ?? "",
          description: quizDetails.description ?? "",
          passPercentage: quizDetails.passPercentage ?? 0,
          questions:
            quizDetails.questions?.map((question) => ({
              question: question.question ?? "",
              isFileAdded: question.isFileAdded ?? false,
              fileIds: question.fileIds ?? [],
              answers: question.answers?.map((answer) => ({
                answer: answer.answer ?? "",
                isCorrected: answer.isCorrected ?? false,
              })),
            })) ?? null,
        }
      : null;
    const formData = {
      lessonId: editLessonData?.id ? editLessonData?.id : "",
      organisationId: ORG_ID(),
      categoryId: iscategryAvilable.length > 0 ? formValue?.categoryId : null, //TODO
      completionTimeHr: formValue?.completionTimeHr ?? 0,
      completionTimeMin: formValue?.completionTimeMin ?? null,
      title: formValue?.title ?? null,
      description: formValue?.description ?? null,
      createdBy: userId ? userId : "",
      createdByApp: null,
      files: images ?? [],
      isGlobal: checkBox,
      DynamicFields: sectionList.length > 0 ? sectionList : [],
      quiz: quizData ? quizData : null,
    };
    const { errorKey } = formValidation(
      {
        title: formValue.title,
        categoryId: formValue.categoryId,
        completionTimeMin: formValue.completionTimeMin,
      },
      action,
    );

    setErrors(errorKey);
    if (embValidData?.length > 0) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        embError: embValidData,
      }));
    }

    let isError = false;
    if (!formValue.title) {
      isError = true;
    }
    if (!formValue.categoryId || iscategryAvilable.length === 0) {
      isError = true;
    }
    if (!formValue.completionTimeMin) {
      isError = true;
    }
    if (hasSectionErr) {
      isError = true;
    }
    if (!isError) {
      setIsSubmit(true);
      onSubmit(formData);
    } else {
      setIsSubmit(false);
    }
  };
  const [formValue, setFormValue] = useState({
    organisationId: ORG_ID(),
    createdBy: userId,
    categoryId: "",
    completionTimeHr: 0,
    completionTimeMin: "",
    title: "",
    description: "",
    Files: "",
    DynamicFields: "",
    quiz: null,
  });

  useEffect(() => {
    if (!lessonData) return;
    setFormValue({
      categoryId: lessonData.categoryId || "",
      completionTimeHr: lessonData.completionTimeHr || 0,
      completionTimeMin: lessonData.completionTimeMin || "",
      title: lessonData.title || "",
      description: lessonData.description || "",
      organisationId: lessonData.organisationId || ORG_ID(),
      createdBy: userId,
      Files: lessonData.files || "",
    });

    if (lessonData.DynamicFields?.length) {
      const newSectionList = lessonData.DynamicFields.map((section) => ({
        id: section.id || `${Date.now()}_${Math.random()}`,
        Text: section.Text || section.text || "",
        embededVideoLink: section.embededVideoLink || "",
        imgFiles: section.imgFiles || [],
        imgFilesUrl: section.imgFilesUrl || [],
        docFiles: section.docFiles || [],
        docFilesUrl: section.docFilesUrl || [],
        organisationId: ORG_ID(),
        createdBy: userId,
        createdByApp: 1,
        sectionId: section.id,
        isImageAdded: section.isImageAdded || false,
        isDocAdded: section.isDocAdded || false,
        videoLink: section.videoLink || "",
      }));
      setSectionList(newSectionList);
    } else {
      setSectionList([]);
    }

    setImages(lessonData.files || []);
    setAddPhoto(lessonData.Filesurl || []);
    setcheckBox(lessonData.isGlobal ?? false);
  }, [lessonData]);

  const handleMinsonChange = (e, value) => {
    const re = /^[0-9\b]+$/;
    if (e.target.value === "" || re.test(e.target.value)) {
      const minval = e.target.value.replace(/^0+/, "");

      setFormValue({
        ...formValue,

        completionTimeMin: minval,
      });
    }
  };
  const handleTitleChange = (event, value) => {
    let fName = event.target.value;
    let finaltitile = fName.replace(/\s+/g, " ");
    setFormValue({
      ...formValue,

      title: finaltitile,
    });
  };

  const handleDescChange = (event, value) => {
    let Desc = event.target.value;
    setFormValue({
      ...formValue,

      description: Desc,
    });
  };

  useEffect(() => {
    if (checkBox) {
      dispatch(lmsAction.getCategoryList({ isGlobal: true, status: true }));
    } else if (checkBox === false && (showSafety || showSW)) {
      dispatch(lmsAction.getCategoryList({ isGlobal: "false", status: true }));
    } else {
      dispatch(lmsAction.getCategoryList({ isGlobal: "", status: true }));
    }
  }, [checkBox]);

  const clearFormValue = React.useCallback(
    (editForm) => {
      if (!lessonData) {
        let coverKeId = [];
        let coverImagePath;
        setAddPhoto(null);

        if (editForm?.file) {
          let coverImageId = editForm?.file?.id;
          coverImagePath = editForm?.file?.path;

          setAddPhoto(coverImagePath);
          coverKeId = [coverImageId];
        }
        setcheckBox(edit && editForm && editForm?.isGlobal);
        setFormValue({
          categoryId: (edit && editForm?.categoryId) ?? "",
          completionTimeHr: (edit && editForm?.completionTimeHr) ?? 0,
          completionTimeMin: (edit && editForm?.completionTimeMin) ?? "",
          description: (edit && editForm?.description) ?? "",
          title: (edit && editForm?.lesson) ?? "",
          organisationId: (edit && editForm?.organisationId) ?? "",
          Files: (edit && coverKeId) ?? "",
          Filesurl: (edit && coverImagePath) ?? "",
        });
        setImages(edit && coverKeId);
      }
    },
    [edit, lessonDetailData],
  );

  useEffect(() => {
    if (isSuccess) {
      clearFormValue();
    }
  }, [isSuccess, clearFormValue]);

  useEffect(() => {
    if (edit) {
      setAddPhoto(null);
      setSectionList([intialState]);
    }
  }, [edit]);

  useEffect(() => {
    if (edit) {
      clearFormValue(editLessonData);
      const newSectionList = [];

      editLessonData?.sections?.map((items) => {
        return newSectionList.push({
          id: items.sectionId,
          Text: items.text,
          embededVideoLink: items.videoLink,
          imgFiles: items?.filesImg[0]?.id ? [items?.filesImg[0]?.id] : [],
          imgFilesUrl: items?.filesImg[0]?.path || [],
          docFiles: items?.filesDoc[0]?.id ? [items?.filesDoc[0]?.id] : [],
          docFilesUrl: items?.filesDoc[0]?.path || [],
          sectionId: items.sectionId,
          organisationId: ORG_ID(),
          createdBy: userId,
          createdByApp: 1,
          isImageAdded: items?.filesImg[0]?.id ? true : false,
          isDocAdded: items?.filesDoc[0]?.id ? true : false,
          videoLink: items.videoLink,
        });
      });

      setSectionList(newSectionList);
    } else {
      if (!lessonData) {
        setSectionList([intialState]);
      }
    }
  }, [edit, clearFormValue, editLessonData, lessonData]);

  const handleOnclickSections = () => {
    //if (sectionList.length < 4) {
    const newSectionList = [...sectionList];
    newSectionList.push({
      id: Date.now() + Math.floor(Math.random() * 100),
      Text: "",
      organisationId: ORG_ID(),
      createdBy: userId,
      createdByApp: 1,
      isDocAdded: false,
      isImageAdded: false,
      embededVideoLink: "",
      imgFiles: [],
      docFiles: [],
    });
    setSectionList(newSectionList);
    // }
  };

  // onchage function
  const handleOnChangeSectionForm = (current, data, type) => {
    let elementId = "";
    let value = "";
    if (type === "uploadPhoto" || type === "uploadDocs" || type === "Text") {
      value = current;
      elementId = type;
    } else {
      value = current.target.value;
      elementId = current.target.id;
    }
    let updatedSectionList = [...sectionList];
    updatedSectionList.forEach((sectionLists) => {
      if (sectionLists.id === data.id) {
        if (elementId === "Text") {
          sectionLists.Text = value;
        } else if (elementId === "embededVideoLink") {
          setErrors({ ...errors, embError: "" });
          sectionLists.embededVideoLink = value;
        } else if (elementId === "uploadPhoto") {
          sectionLists.imgFiles = value;
        } else if (elementId === "uploadDocs") {
          sectionLists.docFiles = value;
        }
      }
    });
    setSectionList(updatedSectionList);
  };
  const [sectionImageData, setSectionImageData] = useState("");
  const [sectionData, setsectionData] = useState("");
  const sectionImageUpload = (files, id, single) => {
    setSectionImageData(id);
    setsectionData(single);
    setAddPhotos(files);
  };

  useEffect(() => {
    if (!lessonData) {
      let updatedSectionList = [...sectionList];

      updatedSectionList.forEach((sectionLists) => {
        if (sectionLists.id === sectionData.id) {
          sectionLists.imgFiles = sectionImageData;
          sectionLists.imgFilesUrl = addPhotos;
          sectionLists.isImageAdded = true;
        }
      });
      setSectionList(updatedSectionList);
    }
  }, [sectionImageData, addPhotos, lessonData]);

  const [sectionFilesDatas, setSectionFilesDatas] = useState("");
  const [sectionDatas, setsectionDatas] = useState("");

  const sectionFileUploads = (files, id, single) => {
    setSectionFilesDatas(id);
    setsectionDatas(single);
    setAddDocs(files);
  };
  useEffect(() => {
    if (!lessonData) {
      let updatedSectionList = [...sectionList];
      updatedSectionList.forEach((sectionListss) => {
        if (sectionListss.id === sectionDatas.id) {
          sectionListss.docFiles = sectionFilesDatas;
          sectionListss.isDocAdded = true;
          sectionListss.docFilesUrl = addDocs;
        }
      });
      setSectionList(updatedSectionList);
    }
  }, [sectionFilesDatas, addDocs, lessonData]);

  const handleDeleteImageURLs = (urls) => {
    let updatedSectionList = [...sectionList];
    updatedSectionList.forEach((sectionListss) => {
      if (sectionListss?.imgFilesUrl === urls) {
        sectionListss.imgFiles = [];
        sectionListss.imgFilesUrl = "";
        sectionListss.isImageAdded = false;
      }
    });
    setSectionList(updatedSectionList);
  };
  const handleDeleteUrlURLs = (urls) => {
    let updatedSectionList = [...sectionList];
    updatedSectionList.forEach((sectionListss) => {
      if (sectionListss?.docFilesUrl === urls) {
        sectionListss.docFiles = [];
        sectionListss.docFilesUrl = "";
        sectionListss.isDocAdded = false;
      }
    });
    setSectionList(updatedSectionList);
  };

  const cancelSectionList = (id) => {
    const removeSectionList = sectionList.filter(
      (section) => section.id !== id,
    );
    setSectionList(removeSectionList);
  };

  const handleViewCreateQuiz = (lessonId, quizId) => {
    navigate(CREATE_QUIZ, {
      state: {
        lessonId: lessonId,
        quizId:
          (editLessonData?.quizId > 0 && edit === "edit") || isQuiz
            ? quizId
            : 0,
        QuizInputData: quizDetails ? quizDetails : null,
        editid: editid,
        lessonInputData: {
          DynamicFields: sectionList.length > 0 ? sectionList : [],
          files: images ?? [],
          Filesurl: addPhoto ?? [],
          categoryId: formValue.categoryId,
          completionTimeHr: formValue?.completionTimeHr ?? 0,
          completionTimeMin: formValue.completionTimeMin,
          createdBy: userId ? userId : "",
          description: formValue?.description ?? null,
          organisationId: ORG_ID(),
          title: formValue?.title ?? null,
          isGlobal: checkBox,
        },
      },
    });
  };

  const checkEmbededVideoLinkExist = (data) => {
    if (data?.embededVideoLink) {
      return data?.id;
    }
  };

  const sortedCategoryList = useMemo(() => {
    return sortAlphabetically(categoryListData?.categoryList);
  }, [categoryListData]);

  const dataBack = {
    title: "Back",
    route: LESSON,
  };

  return (
    <>
      {<BackBtn dataBack={dataBack} className="equipmentBack" />}
      <div className="overideLessons">
        <div className="formContainer">
          <div className="title">
            {edit || isLessonEditMode ? (
              <div className="heading_style">
                <h1>Update Lesson</h1>
              </div>
            ) : (
              <div className="heading_style">
                <h1>Create Lesson</h1>
              </div>
            )}
          </div>
          <div className="addLessonBoxContainer">
            <div className="addlessonBox">
              <Grid>
                {(showSafety || showSW) && (
                  <Grid container>
                    <Grid item lg={6} xs={12} sm={12} md={4} mt={2}>
                      <div className="typeTxt">
                        <Checkbox
                          checked={checkBox}
                          onChange={() => {
                            setcheckBox(!checkBox);
                            setFormValue({
                              ...formValue,
                              categoryId: "",
                            });
                          }}
                          label={"Is Global"}
                        />
                      </div>
                    </Grid>
                  </Grid>
                )}
                <Grid item container mt={4} lg={12} spacing={1}>
                  <Grid item lg={6} xs={12} sm={12} md={6}>
                    <FormControl fullWidth>
                      <FormLabels label="Category" isRequired={true} />
                      <SelectMenu
                        listData={sortedCategoryList}
                        value={formValue.categoryId}
                        isRequired={true}
                        placeholder="Select Category"
                        onchangehandler={(e) =>
                          setFormValue({
                            ...formValue,
                            categoryId: e.target.value,
                          })
                        }
                        isError={!!errors?.categoryId ?? false}
                        errorMsg={errors?.categoryId ?? ""}
                      />
                    </FormControl>
                  </Grid>

                  <Grid item lg={6} xs={12} sm={12} md={6}>
                    <FormControl fullWidth>
                      <FormLabels
                        label={"Completion Time Minute"}
                        isRequired={true}
                      />

                      <InputField
                        fullWidth={true}
                        disabled={false}
                        type="text"
                        placeholder="Enter in Minutes"
                        value={formValue.completionTimeMin}
                        onChange={(event, value) =>
                          handleMinsonChange(event, value)
                        }
                        isError={!!errors?.completionTimeMin ?? false}
                        errorMsg={errors?.completionTimeMin ?? ""}
                      />
                    </FormControl>
                  </Grid>
                </Grid>
              </Grid>

              <Grid container>
                <Grid lg={12} xs={12} sm={12} spacing={2} mt={3}>
                  <FormLabels label={"Add Lesson Cover Image"} />
                  <ImageUploader
                    handleFileChange={(filesPath, fileDataId) => {
                      setAddPhoto(filesPath);
                      setImages(fileDataId);
                    }}
                    imageUrl={addPhoto || lessonData?.Filesurl}
                  />
                </Grid>
              </Grid>
              <Grid mt={1.5} spacing={2} lg={12}>
                <FormControl fullWidth>
                  <InputField
                    isRequired={true}
                    fullWidth={true}
                    disabled={false}
                    type="text"
                    label="Title"
                    placeholder="Enter title text here..."
                    value={formValue.title}
                    onChange={(event, value) => handleTitleChange(event, value)}
                    isError={!!errors?.title ?? false}
                    errorMsg={errors?.title ?? ""}
                  />
                </FormControl>
              </Grid>

              <Grid mt={3} spacing={2} lg={12}>
                <FormLabels label={"Description"} />
                <TextArea
                  name={"issuefound"}
                  placeholder="Add lesson description text here..."
                  value={formValue.description}
                  onChange={(event, value) => handleDescChange(event, value)}
                />
              </Grid>
              {sectionList?.map((singleSection, index) => (
                <>
                  <Section
                    key={index + 1}
                    keyNo={index + 1}
                    singleSection={singleSection}
                    handleOnChangeSectionForm={handleOnChangeSectionForm}
                    isErrorSectionName={singleSection.isErrorSectionName}
                    isErrorStatement={singleSection.isErrorStatement}
                    errorSectionNameMsg={singleSection.errorSectionNameMsg}
                    errorStatementMsg={singleSection.errorStatementMsg}
                    id={singleSection.id}
                    sectionImageUpload={(photo, id) =>
                      sectionImageUpload(photo, id, singleSection)
                    }
                    sectionFileUploads={(photo, id) =>
                      sectionFileUploads(photo, id, singleSection)
                    }
                    cancelSectionList={(id) => cancelSectionList(id)}
                    deleteImageURL={(url) => handleDeleteImageURLs(url)}
                    deleteUrlURL={(url) => handleDeleteUrlURLs(url)}
                    isCloneOf={isCloneOf}
                    check={() => checkEmbededVideoLinkExist(singleSection)}
                    lessonName={lessonDetailData?.lesson}
                    errors={errors && errors?.embError?.[index]}
                  />
                </>
              ))}
              <div className="addBox">
                <Button
                  variantOutlineSections={true}
                  disabled={sectionList.length === 4 ? true : false}
                  label=" Add New Section"
                  onClick={handleOnclickSections}
                />
              </div>

              <Grid container textAlign="left" alignItems="center">
                <Grid container mt={7}>
                  <Grid container textAlign="left" alignItems="left">
                    <Grid md={3}>
                      <Button
                        startIcon={<AddIcon />}
                        varientContained={true}
                        label={
                          (editLessonData?.quizId > 0 && edit === "edit") ||
                          isQuiz
                            ? "Edit Quiz"
                            : "Create Quiz"
                        }
                        onClick={() =>
                          handleViewCreateQuiz(
                            editLessonData?.id ?? 0,
                            editLessonData?.quizId ?? 0,
                          )
                        }
                      />
                    </Grid>
                  </Grid>
                  {/* )} */}

                  <Grid item mb={3} container mt={1} className="lessonBtn">
                    <Grid
                      container
                      textAlign="right"
                      alignItems="center"
                      className="addlessonButton"
                    >
                      <Grid item lg={4} mt={1} textAlign="center">
                        <Button
                          varientContained={true}
                          disabled={isSubmit ? true : false}
                          label={
                            edit === "edit" || isLessonEditMode
                              ? "Update"
                              : "Create Lesson"
                          }
                          onClick={(e) =>
                            formHandler(
                              e,
                              edit === "edit" ? "update" : "submit",
                            )
                          }
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default AddLessons;
